import type { BootstrapResponse } from "@snowiespace/protocol";
import type { IconName } from "@snowiespace/ui/web";

export type CatalogModule = BootstrapResponse["modules"][number];

function configuration(module: CatalogModule): Record<string, unknown> {
  return module.view.configuration && typeof module.view.configuration === "object"
    ? module.view.configuration as Record<string, unknown>
    : {};
}

export function catalogIcon(module: CatalogModule): IconName {
  if (module.view.kind === "schedule") return "schedule";
  if (module.view.kind === "app") return "workbench";
  if (module.view.kind === "app_runtime") return "app";
  if (module.view.kind === "resource") {
    const config = configuration(module);
    if (config.contentFormat === "markdown") return "page";
    if (config.binaryTransfer === "file") return "desk";
    return "file";
  }
  return "app";
}

export function catalogDescription(module: CatalogModule): string {
  if (module.view.kind === "schedule") return "Target-bound routines and durable execution receipts";
  if (module.view.kind === "app") return "Build and review Apps before composition activation";
  if (module.view.kind === "app_runtime") return "Installed App contained by the public bridge";
  if (module.view.kind === "resource") {
    const config = configuration(module);
    if (config.contentFormat === "markdown") return "Shared Pages, revisions, attachments, and publication";
    if (config.binaryTransfer === "file") return "Space files, folders, previews, and exact leases";
    return "Registered Space resources";
  }
  return "Registered module operations";
}
